export default "__VITE_ASSET__3vuMwpi___"